"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var icon_1 = __importDefault(require("../../icon"));
var ListItem_1 = __importDefault(require("./ListItem"));
// 最大支持展示数量
var MAX_CARD_LEN = 4;
/**
 * 渲染标签
 */
function renderTag(tagTxt) {
    return react_1.default.createElement("div", { className: "activity-tips" }, tagTxt);
}
/**
 * 渲染左侧第一栏
 */
function renderLeft(props) {
    var firstTitle = props.firstTitle, firstDesc = props.firstDesc;
    return (react_1.default.createElement("div", { className: "horizontal-item-left" },
        react_1.default.createElement("div", { className: "item-title" }, firstTitle),
        react_1.default.createElement("div", { className: "item-desc" }, firstDesc)));
}
/**
 * 渲染中间栏
 */
function renderList(props) {
    var _a = props.list, list = _a === void 0 ? [] : _a, _b = props.descList, descList = _b === void 0 ? [] : _b;
    return (react_1.default.createElement("div", { className: "horizontal-item-center" },
        list.length > 0 && (react_1.default.createElement("div", { className: (0, classnames_1.default)('item-center-list', {
                'product-list': descList.length > 0,
            }) }, list.map(renderMidListItem))),
        descList.length > 0 && (react_1.default.createElement("ul", { className: (0, classnames_1.default)('item-center-desc', {
                'desc-has-top': list.length > 0,
            }) }, descList.map(renderDescList)))));
}
/**
 * 渲染价格套餐描述列表
 * @param item list数据
 * @param index map循环的index
 */
function renderDescList(item, index) {
    var txt = item.txt;
    return (react_1.default.createElement("li", { className: "desc-item", key: index },
        react_1.default.createElement(icon_1.default, { name: "check", size: 18, color: "#006EFF", className: "desc-icon" }),
        react_1.default.createElement("span", { className: "desc-item_span" }, txt)));
}
/**
 * 渲染中间栏列表
 * @param item list数据
 * @param index map循环的index
 */
function renderMidListItem(item, index) {
    // 限制最大数量
    if (index >= MAX_CARD_LEN) {
        return null;
    }
    return react_1.default.createElement(ListItem_1.default, __assign({ key: "list-item-".concat(index) }, item));
}
/**
 * 渲染右侧第三栏
 */
function renderRight(props) {
    var bigNum = props.bigNum, smallTxt = props.smallTxt, thirdDesc = props.thirdDesc, btnTxt = props.btnTxt, onCallback = props.onCallback, extendProps = props.extendProps;
    return (react_1.default.createElement("div", { className: "horizontal-third" },
        react_1.default.createElement("div", { className: "horizontal-third-swap" },
            react_1.default.createElement("div", { className: "horizontal-third-num" },
                react_1.default.createElement("div", { className: "item-big" }, bigNum),
                react_1.default.createElement("div", { className: "item-small" }, smallTxt)),
            react_1.default.createElement("div", { className: "horizontal-third-desc" },
                react_1.default.createElement("div", { className: "desc-content" }, thirdDesc)),
            react_1.default.createElement("div", { className: "horizontal-third-btn" },
                react_1.default.createElement("div", __assign({ className: "btn-txt", onClick: function () {
                        onCallback === null || onCallback === void 0 ? void 0 : onCallback();
                    } }, (extendProps || {})), btnTxt)))));
}
function PriceSetHorizontalItem(props) {
    var tagTxt = props.tagTxt;
    return (react_1.default.createElement("div", { className: "price-set-main-item" },
        tagTxt && renderTag(tagTxt),
        renderLeft(props),
        renderList(props),
        renderRight(props)));
}
exports.default = PriceSetHorizontalItem;
//# sourceMappingURL=PriceSetHorizontalItem.js.map